module.exports = __webpack_public_path__ + "img/electronic.338a2856.svg";